import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Channel } from 'ops/common/models/channel';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getByFcuChannelId(fcuChannelId: number): Observable<Channel> {
        return this.http.get<Channel>(
            `${this.domain}/api/ops/channels/fcuChannelId/${fcuChannelId}`,
        );
    }

    public getChannels(): Observable<Channel[]> {
        return this.http.get<Channel[]>(`${this.domain}/api/ops/channels`);
    }

    public get(channelId: string): Observable<Channel> {
        return this.http.get<Channel>(`${this.domain}/api/ops/channels/${channelId}`);
    }

    public update(channel: Channel): Observable<string> {
        return this.http.put<string>(`${this.domain}/api/ops/channels/${channel.id}`, channel);
    }
}
